<div class="list-container" >
  <dynamic-table [props]="props">
    <table class="table">
      <thead>
      <tr class="table-header">
        <th id="Name" class="table-header-title l-table-width-450">{{'users.name' | translate}}</th>
        <th id="Email" class="table-header-title l-table-width-370">{{'users.email' | translate}}</th>
        <th id="Phone" class="table-header-title l-table-width-300">{{'users.phoneNo' | translate}}</th>
        <th id="Active" class="table-header-title l-table-width-250">{{'users.isActive' | translate}}</th>
        <th class="table-header-title"></th>
      </tr>
      </thead>

      <tbody>
      <ng-container *ngFor="let user of users; let userIndex = index">
        <tr class="row-container ccc">
          <td HJSuppress id="Name" class="column-content table-main-td" (click)="viewDetails(user.userId)">
            {{user.name}}
          </td>
          <td HJSuppress id="Email" class="column-content">
            {{user.email}}
          </td>
          <td HJSuppress id="Phone" class="column-content">
            {{user.phone}}
          </td>
          <td id="IsActive" class="column-content">
            <kendo-switch [(ngModel)]="user.isActive"
                          name="users-switch-{{userIndex}}"
                          (valueChange)="changeUserStatus(user.userId, $event)"
            >
            </kendo-switch>
          </td>

          <td class="column-content">
            <button class="btn delete-btn gap-2"
                    [disabled]="!user.isActive"
                    (click)="user.isActive && viewDetails(user.userId)">
              <i class="app-icon icon icon-edit icon-lg"></i>
              <span>{{'users.add.placeholder.userDetails' | translate}}</span>
            </button>
          </td>

          <td class="column-content">
            <div class="divider"></div>
          </td>

          <td class="column-content">
            <button class="btn delete-btn gap-2"
                    [disabled]="!user.isActive"
                    (click)="user.isActive && redirectUserRights(user.userId)">
              <i class="app-icon icon icon-edit icon-lg"></i>
              <span>{{'users.add.placeholder.userRights' | translate}}</span>
            </button>
          </td>

          <td class="column-content">
            <button class="btn delete-btn delete-btn-circle"
                    (click)="deleteUser(user.userId)">
              <i class="app-icon icon icon-delete icon-lg"></i>
            </button>
          </td>
        </tr>
      </ng-container>
      </tbody>
    </table>
  </dynamic-table>
</div>
